import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Metrics } from './components/sections/Metrics';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { ContentSystem } from './components/sections/ContentSystem';
import { Delivery } from './components/sections/Delivery';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  useMetaPixel();
  return <div className="w-full min-h-screen bg-cream font-sans antialiased overflow-x-hidden" data-id="element-0" data-mp="3ij66mgga9xb1">
      <main className="w-full" data-id="element-1" data-mp="3mkhnnxl3da7m">
        <Hero data-id="element-2" data-mp="3mjg9hk8s47lo" />
        <Metrics data-id="element-3" data-mp="3mj6lg27aoaim" />
        <BeforeAfter data-id="element-4" data-mp="3rcj31sdk3h1v" />
        <PainPoints data-id="element-5" data-mp="3rdapodp6e4g0" />
        <ContentSystem data-id="element-6" data-mp="3rcswjpxt86cb" />
        <Delivery data-id="element-7" data-mp="3reltgdimfc74" />
        <Bonuses data-id="element-8" data-mp="5otf64sd496" />
        <Offer data-id="element-9" data-mp="67yhm9c7y5s" />
        <Guarantee data-id="element-10" data-mp="4n4bxqxqh8g" />
        <Testimonials data-id="element-11" data-mp="56mnfkhz7n0" />
        <About data-id="element-12" data-mp="7stte3h7l4p" />
        <Faq data-id="element-13" data-mp="2zld2jatxbhc2" />
        <FinalCTA data-id="element-14" data-mp="2zlv66six0xu0" />
      </main>
      <Footer data-id="element-15" data-mp="2zmo6bandcp36" />
      <FloatingCTA data-id="element-16" data-mp="2zn6actg9w7ln" />
      <PurchasePopup data-id="element-17" data-mp="33mouvo46mgny" />
    </div>;
}